module.exports = __webpack_public_path__ + "static/media/kitchen_app_icon.c0ce96e9.svg";